export const APP_ROUTE_VIEWS = {
  inventorization: 'inventorization',
  meters: 'meters',
  scan: 'scan',
  settings: 'settings',
  sync: 'sync',
  today: 'today',
} as const;

export type AppRouteView = (typeof APP_ROUTE_VIEWS)[keyof typeof APP_ROUTE_VIEWS];

export const inventoryRoutes = {
  inventorize: '/inventorize/:sessionId',
  inventorizeField: '/inventorize/:sessionId/field/:fieldId',
  inventorizePhoto: '/inventorize/:sessionId/photos/:slotId',
  inventorizeReview: '/inventorize/:sessionId/review',
  meters: '/meters',
  root: '/',
  scan: '/scan',
  settings: '/settings',
  sync: '/sync',
} as const;

export function inventorizeReviewPath(sessionId: string) {
  return `/inventorize/${encodeURIComponent(sessionId)}/review`;
}

export function inventorizeFieldPath(sessionId: string, fieldId: string) {
  return `/inventorize/${encodeURIComponent(sessionId)}/field/${encodeURIComponent(fieldId)}`;
}

export function getRouteView(pathname: string): AppRouteView {
  if (pathname === inventoryRoutes.scan) {
    return APP_ROUTE_VIEWS.scan;
  }

  if (pathname === inventoryRoutes.meters) {
    return APP_ROUTE_VIEWS.meters;
  }

  if (pathname === inventoryRoutes.sync) {
    return APP_ROUTE_VIEWS.sync;
  }

  if (pathname === inventoryRoutes.settings) {
    return APP_ROUTE_VIEWS.settings;
  }

  if (pathname.startsWith('/inventorize/')) {
    return APP_ROUTE_VIEWS.inventorization;
  }

  return APP_ROUTE_VIEWS.today;
}
